export default [
    {
        path: '/audit',
        name: 'audit',
        component: () => import('@/views/pages/audit/AuditPage.vue'),
        meta: {
            resource: 'Audit',
            action: 'manage',
            // No pageTitle/breadcrumb: the page card shows the title (avoids a duplicate header)
        },
    },
]
